export const BORDER_STYLE_PRIMARY = '2px solid black';
export const BORDER_STYLE_SECONDARY = '1px solid black';
export const BACKGROUND_COLOR_HEADER = '#eeeeee';
